import { render, staticRenderFns } from "./shopOrders.vue?vue&type=template&id=22c5ecb0&scoped=true&"
import script from "./shopOrders.vue?vue&type=script&lang=ts&"
export * from "./shopOrders.vue?vue&type=script&lang=ts&"
import style0 from "./shopOrders.vue?vue&type=style&index=0&id=22c5ecb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c5ecb0",
  null
  
)

export default component.exports